import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineExpirationNotificationDto extends EpimsBaseEntityDto   {
    PipelineId: string;
    PipelineName: string;
 
    PipelineExpiringDate: Date;
    NotificationContent: string;
    NotificationSentTo: string;
    NotificationSentDate: Date;
    NotificationPeriod: string;
}